import ModalDialog from 'Components/ModalDialog';
import React, { FunctionComponent } from 'react';
import { useSelector } from "react-redux"
import { ModalBody, ModalFooter, ModalDescription } from './styled.components'
import Buttons from "../../Components/Buttons"
import Spinner from "../../Components/Spinner"

type ConfirmationModalProps = {
    open: boolean
    description?: string
    modalSize?: string
    isLoading?: boolean
    handleConfirmClick: () => void
    handleCancelClick: () => void
}

const ConfirmationModal: FunctionComponent<ConfirmationModalProps> = ({ open, description, modalSize, isLoading = false, handleConfirmClick, handleCancelClick }) => {

    const { btnSimple } = useSelector((state: any) => state.theme)

    const style = {
        borderRadius: 5
    }

    return (
        <div>
            <ModalDialog open={open} modalSize={modalSize} background={"#A0a0a0"} styles={style}>
                <>
                    <ModalBody>
                        <ModalDescription>{description}</ModalDescription>
                    </ModalBody>
                    <ModalFooter>
                        {isLoading ? (
                            <Spinner />
                        ) : (
                            <>   <Buttons
                                title={"Cancelar"}
                                type={"cancel-confirmation"}
                                config={btnSimple}
                                handleClick={handleCancelClick}
                            />
                                <Buttons
                                    title={"Confirmar"}
                                    type={"accept-confirmation"}
                                    config={btnSimple}
                                    handleClick={handleConfirmClick}
                                />
                            </>
                        )}
                    </ModalFooter>
                </>
            </ModalDialog>
        </div>
    )
}

export default ConfirmationModal